import axios from 'axios'
import router from '../../router'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  apiPayments (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      if (payload.flag === 'Access') {
        // console.log(payload)
        return new Promise((resolve, reject) => {
          const secretKey = 'test_sk_Kma60RZblrqL1N050XzVwzYWBn14'
          const payparams = {
            'orderId': payload.idOrder,
            'amount': payload.amount,
            'paymentKey': payload.paymentKey,
            'flag': 'Access'
          }
          axios.post('https://api.tosspayments.com/v1/payments/' + payparams.paymentKey, payparams, {headers: {Authorization: 'Basic ' + Buffer.from(secretKey + ':').toString('base64'), 'Content-Type': 'application/json'}})
            .then((response) => {
              // console.log(response.data)
              payload.idOrder = response.data.orderId
              payload.requestAt = response.data.requestedAt
              payload.totalamount = response.data.totalAmount
              payload.bank = response.data.virtualAccount.bank
              payload.virtualAccnt = response.data.virtualAccount.accountNumber
              payload.dueAt = response.data.virtualAccount.dueDate
              payload.secret = response.data.secret
              payload.status = response.data.status
              // console.log(payload)
              axios.post('/api/member/estate/insertEstate', payload)
                .then((response) => {
                  resolve(response.data)
                })
                .catch((error) => {
                  alert(error.response.data.message)
                  if (error.response.status === 403) {
                    sessionStorage.removeItem('token')
                    alert('세션 만료 또는 잘못된 접근 입니다.')
                    router.push('/')
                  }
                })
            })
            .catch((error) => {
              reject(error.response.data.message)
              alert(error.response.data.message)
              router.push('/')
            })
        })
      }
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/')
    }
  },
  apiDocPayments (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      if (payload.flag === 'Access') {
        // console.log(payload)
        return new Promise((resolve, reject) => {
          const tmpInfo = payload.docInfo
          const secretKey = 'test_sk_Kma60RZblrqL1N050XzVwzYWBn14'
          axios.post('https://api.tosspayments.com/v1/payments/' + payload.paymentKey, payload, {headers: {Authorization: 'Basic ' + Buffer.from(secretKey + ':').toString('base64'), 'Content-Type': 'application/json'}})
            .then((response) => {
              // console.log(response.data)
              const params = {
                'idOrder': response.data.orderId,
                'requestAt': response.data.requestedAt,
                'totalamount': response.data.totalAmount,
                'bank': response.data.virtualAccount.bank,
                'virtualAccnt': response.data.virtualAccount.accountNumber,
                'dueAt': response.data.virtualAccount.dueDate,
                'secret': response.data.secret,
                'status': response.data.status,
                'docInfo': tmpInfo,
                'paymentKey': payload.paymentkey
              }
              // console.log('apiDocPayments = ' + JSON.stringify(params))
              axios.post('/api/member/payment/insertDocPayOrder', params)
                .then((response) => {
                  resolve(response.data)
                })
                .catch((error) => {
                  if (error.response.status === 403) {
                    sessionStorage.removeItem('token')
                    alert('세션 만료 또는 잘못된 접근 입니다.')
                    router.push('/')
                  }
                  // alert(error.response.data.message)
                })
            })
            .catch((error) => {
              reject(error.response.data.message)
              alert(error.response.data.message)
              router.push('/')
            })
        })
      }
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/')
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/payments.js